import { type UseQueryResult, useQuery } from 'react-query';
import { TransactionService } from '../../services/wealthlane-award-services';

const useGetTransactionSettlementStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const transactionSettlementStatus = useQuery(
    ['getTransactionSettlementStatus'],
    async () => {
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionSettlementStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionSettlementStatus;
};

export default useGetTransactionSettlementStatus;
